// extracted by mini-css-extract-plugin
export default {"wrapper":"ConnectionInfo_wrapper__VsFMz","connectionRegionLabelWrapper":"ConnectionInfo_connectionRegionLabelWrapper__z6YgU"};